import { postReq } from './api';

export interface StoredFile {
  file_id: string;
  file_url: string;
}

// Uploads a file to the shared file store and returns its id and a signed url. The id can then
// be attached to a record (e.g. an official's ID card) by whichever endpoint owns that record.
export const createFile = async (
  accessToken: string,
  file: File
): Promise<{ data?: StoredFile; error?: string }> => {
  const formData = new FormData();
  formData.append('file', file);

  return postReq<StoredFile>(
    '/files',
    accessToken,
    formData,
    'Failed to upload file.',
    'multipart/form-data'
  );
};
